<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-3" [routerLink]="['/settings/team/roles-permissions']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-8">
      @if (roleId) {
      <h2 class="col pb-2 m-0 title">
        {{ "EDITROLE" | translate }}
      </h2>
      } @else {
      <h2 class="col pb-2 m-0 title">
        {{ "ADDROLE" | translate }}
      </h2>
      }
      <p class="col subtitle">
        {{ "ROLESETUP_SUBTITLE" | translate }}
      </p>
    </div>
    <div class="col-md-3 d-flex justify-content-end pe-5 text-nowrap">
      <button class="col-auto add justify-content-center align-items-center p-2" type="submit" (click)="onSubmit()"
              [disabled]="roleName.invalid">
        {{ "SAVE_CHANGES" | translate }}
      </button>
    </div>
  </div>
  <form #crudform="ngForm" (ngSubmit)="onSubmit()">
    <div class="form-item">
      <label class="form-label" for="roleName">{{ "ROLE" | translate }} {{ "NAME" | translate }}</label>
      <div class="form-input">
        <input id="roleName" [(ngModel)]="data.name" #roleName="ngModel" name="roleName" type="text" required />
        @if (crudform.submitted && roleName.invalid) {
        <div class="validation-error">
          {{ "ROLE" | translate }}{{ "NAME" | translate
          }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
        </div>
        } @else if (!roleName.valid) {
        <div class="validation-instruction">
          {{ "ROLESETUP_ROLENAMEDESC" | translate }}
        </div>
        }
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div class="row g-0 layout">
      <span class="sidemenu-title pb-3">
        {{ "SELECTPERMISSIONS" | translate }}
      </span>
      @for (group of permissionGroups; track group.name) {
        @if (group.permissions.length > 0) {
          <div class="category-container p-3">
            <div class="d-flex align-items-center justify-content-between">
              <span class="item-name text-capitalize">{{ ("ROLE_GROUP_" + group.name) | uppercase | translate }}</span>
              <label class="switch pe-2">
                <input type="checkbox" [id]="'selectAll-' + group.name" [checked]="group.selectAll"
                       (change)="toggleSelectAllPermissions(group, $event)" />
                <span class="slider round"></span>
              </label>
            </div>
            <div class="row g-0 mt-4 permission-container">
              @for(permission of group.permissions; track permission) {
                <div class="col-6 g-0 m-0 p-3 permision">
                  <div class="d-flex align-items-center">
                    <label class="switch">
                      <input type="checkbox" [id]="'checkbox-' + permission"
                             [checked]="data.permissions?.includes(permission)"
                             (change)="togglePermission(permission, $event)" />
                      <span class="slider round"></span>
                    </label>
                    <span class="ps-2 text-capitalize">{{ ("ROLE_" + permission) | uppercase | translate }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </form>
</div>
